module.exports = __webpack_public_path__ + "434d3dc2ca60466e946748ffb262deb0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-22.png
// module id = 3216
// module chunks = 0